import React from 'react';
import { isBlank } from 'utils/helperMethods';
import { pathOr } from 'ramda';
import PropTypes from 'prop-types';

import { Box } from '@material-ui/core';
import Chat from 'sharedComponents/Chat';

import UserPresenter from 'presenters/UserPresenter';
import BidRequestPresenter from 'presenters/BidRequestPresenter';
import FirebaseChatPresenter from 'presenters/FirebaseChatPresenter';
import ChatPresenter, { buildChatCurrentUser } from 'presenters/ChatPresenter';

import useFirebaseChat from 'reducers/hooks/firebase/useChat';

import BuyerCard from './components/BuyerCard';

import useStyles from './useStyles';

const ChatPage = props => {
  const classes = useStyles();
  const {
    isOnline,
    currentUser,
    onMessageSend,
    onMessagesRead,
    onBack,
    chatInfo,
    chat,
    bidRequest,
    selectedChatUid,
    onOpenLoanOfficerPage,
    chatParticipant,
  } = props;

  const { usersOnlineStatusList, messages, isMessagesLoaded } = useFirebaseChat();

  const buyerId = FirebaseChatPresenter.buyerId(chat);
  const buyer = isBlank(chatInfo) ? null : ChatPresenter.buyer(chatInfo);
  const isParticipantOnline = pathOr(false, [buyerId, 'isOnline'], usersOnlineStatusList);

  const chatCurrentUser = buildChatCurrentUser(currentUser, isOnline);
  const selectedChatMessages = messages[selectedChatUid];
  const isLoanOfficer = UserPresenter.isLoanOfficer(currentUser);

  return (
    <Box className={classes.paper}>
      <BuyerCard
        buyer={buyer}
        isOnline={isParticipantOnline}
        onClick={onOpenLoanOfficerPage}
        bidRequest={bidRequest}
        onBack={onBack}
      />
      <Box className={classes.chatBox}>
        <Chat
          isLoanOfficer={isLoanOfficer}
          chatCurrentUser={chatCurrentUser}
          chatParticipant={chatParticipant}
          messages={selectedChatMessages}
          isMessagesLoading={!isMessagesLoaded}
          chatUid={selectedChatUid}
          onMessageSend={onMessageSend}
          onMessagesRead={onMessagesRead}
        />
      </Box>
    </Box>
  );
};

ChatPage.propTypes = {
  chat: FirebaseChatPresenter.shape().isRequired,
  chatInfo: ChatPresenter.shape(),
  selectedChatUid: PropTypes.string.isRequired,
  bidRequest: BidRequestPresenter.shape(),
  onBack: PropTypes.func.isRequired,
  isOnline: PropTypes.bool.isRequired,
  currentUser: UserPresenter.shape().isRequired,
  onMessageSend: PropTypes.func.isRequired,
  onMessagesRead: PropTypes.func.isRequired,
  onOpenLoanOfficerPage: PropTypes.func.isRequired,
};

ChatPage.defaultProps = {
  bidRequest: {},
  chatInfo: {},
};

export default ChatPage;



// WEBPACK FOOTER //
// ./src/components/LoanOfficerMessages/components/MobileMessages/components/ChatPage/ChatPage.js